/**
 * @class Oskari.mapframework.bundle.system_message.SystemBundle
 *
 * Definition for bundle. See source for details.
 * // NBA customized
 *  * Only one overwritten file so we can modify onClick when gfi is clicked
 * TODO: get rid of this modification
 * // bundles/overwritten/mapping/mapwfs2/plugin/WfsVectorLayerPlugin/ReqEventHandler.js
 */
Oskari.clazz.define('Oskari.wfsvector.WfsVectorBundle', function () {}, {
  create: function create() {
    return this;
  },
  update: function update(manager, bundle, bi, info) {}
}, {
  protocol: ['Oskari.bundle.Bundle'],
  source: {
    scripts: [{
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/service/WFSLayerService.js'
    }, {
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/event/WFSStatusChangedEvent.js'
    }, {
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/request/ActivateHighlightRequest.js'
    }, {
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/request/ActivateHighlightRequestHandler.js'
    }, {
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/event/WFSFeaturesSelectedEvent.js'
    }, {
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/domain/WFSLayer.js'
    }, {
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/domain/WfsLayerModelBuilder.js'
    }, {
      type: 'text/javascript',
      src: '../../../bundles/overwritten/mapping/mapwfs2/plugin/WfsVectorLayerPlugin.ol.js'
      // src: "oskari-frontend/bundles/mapping/mapwfs2/plugin/WfsVectorLayerPlugin.ol.js"
    }],
    locales: [{
      lang: 'en',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/en.js'
    }, {
      lang: 'es',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/es.js'
    }, {
      lang: 'et',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/et.js'
    }, {
      lang: 'fi',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/fi.js'
    }, {
      lang: 'fr',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/fr.js'
    }, {
      lang: 'is',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/is.js'
    }, {
      lang: 'it',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/it.js'
    }, {
      lang: 'sv',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/sv.js'
    }, {
      lang: 'nb',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/nb.js'
    }, {
      lang: 'nl',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/nl.js'
    }, {
      lang: 'nn',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/nn.js'
    }, {
      lang: 'sl',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/sl.js'
    }, {
      lang: 'sk',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/sk.js'
    }, {
      lang: 'de',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/de.js'
    }, {
      lang: 'cs',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/cs.js'
    }, {
      lang: 'ru',
      type: 'text/javascript',
      src: 'oskari-frontend/bundles/mapping/mapwfs2/resources/locale/ru.js'
    }]
  },
  bundle: {
    manifest: {
      'Bundle-Identifier': 'wfsvector',
      'Bundle-Name': 'wfsvector',
      'Bundle-Author': [{
        Organisation: 'nls.fi',
        Temporal: {
          Start: '2018'
        },
        Copyleft: {
          License: {
            'License-Name': 'EUPL',
            'License-Online-Resource': 'http://www.paikkatietoikkuna.fi/license'
          }
        }
      }],
      'Bundle-Version': '1.0.0',
      'Import-Namespace': ['Oskari', 'jquery'],
      'Import-Bundle': {}
    }
  }
});
Oskari.bundle_manager.installBundleClass('mapwfs2', 'Oskari.wfsvector.WfsVectorBundle');
import 'oskari-frontend/bundles/mapping/mapwfs2/service/WFSLayerService.js'
import 'oskari-frontend/bundles/mapping/mapwfs2/event/WFSStatusChangedEvent.js'
import 'oskari-frontend/bundles/mapping/mapwfs2/request/ActivateHighlightRequest.js'
import 'oskari-frontend/bundles/mapping/mapwfs2/request/ActivateHighlightRequestHandler.js'
import 'oskari-frontend/bundles/mapping/mapwfs2/event/WFSFeaturesSelectedEvent.js'
import 'oskari-frontend/bundles/mapping/mapwfs2/domain/WFSLayer.js'
import 'oskari-frontend/bundles/mapping/mapwfs2/domain/WfsLayerModelBuilder.js'
import '../../../bundles/overwritten/mapping/mapwfs2/plugin/WfsVectorLayerPlugin.ol.js'